import {DeviceActionType} from '@/constants/deviceActionType';

/**
 * @param {WIFI_STATUS} status
 * @returns
 */
export const UpdateDeviceWifiStatus = (status) => ({
  type: DeviceActionType.WIFI_STATUS,
  value: status,
});

/**
 * @param {POWER} status {@link POWER}
 * @returns
 */
export const UpdateDevicePowerStatus = (status) => ({
  type: DeviceActionType.POWER,
  value: status,
});

/**
 * @param {TIMEZONE} status {@link TIMEZONE}
 * @returns
 */
export const UpdateTimezone = (status) => ({
  type: DeviceActionType.TIMEZONE,
  value: status,
});

export const UpdateUserSelectedTimezone = (status) => ({
  type: DeviceActionType.USER_SELECTED_TIMEZONE,
  value: status,
});

export const UpdateUserSelectedTime = (status) => ({
  type: DeviceActionType.USER_SELECTED_TIME,
  value: status,
});

export const UpdateUserSelectedDate = (status) => ({
  type: DeviceActionType.USER_SELECTED_DATE,
  value: status,
});

export const UpdateOriginTimezone = (status) => ({
  type: DeviceActionType.ORIGIN_TIMEZONE,
  value: status,
});

export const OnEditTimezoneSetting = (value) => ({
  type: DeviceActionType.EDIT_TIMEZONE_SETTING,
  value,
});

/**
 * @param {TIMEZONE_CHANGED} status {@link TIMEZONE_CHANGED}
 * @returns
 */
export const UpdateTimezoneChanged = (status) => ({
  type: DeviceActionType.TIMEZONE_CHANGED,
  value: status,
});

/**
 * @param {SET_TIMEZONE_OPTION} status {@link SET_TIMEZONE_OPTION}
 * @returns
 */
export const UpdateTimezoneSetting = (status) => ({
  type: DeviceActionType.SET_TIMEZONE_OPTION,
  value: status,
});

/**
 * @param {SET_TIMEZONE_OPTION_MANUAL} status {@link SET_TIMEZONE_OPTION_MANUAL}
 * @returns
 */
export const UpdateTimezoneSettingManual = (status) => ({
  type: DeviceActionType.SET_TIMEZONE_OPTION_MANUAL,
  value: status,
});

/**
 * @param {SET_TIMEZONE_OPTION_MANUAL_ORIGINAL} status {@link SET_TIMEZONE_OPTION_MANUAL_ORIGINAL}
 * @returns
 */
export const UpdateTimezoneSettingManualOriginal = (status) => ({
  type: DeviceActionType.SET_TIMEZONE_OPTION_MANUAL_ORIGINAL,
  value: status,
});

/**
 * @param {DATETIME_CHANGED} status {@link DATETIME_CHANGED}
 * @returns
 */
export const UpdateDateTimeChanged = (status) => ({
  type: DeviceActionType.DATETIME_CHANGED,
  value: status,
});
